import { render } from "./LargeIcon.vue?vue&type=template&id=29739d3d&scoped=true"
import script from "./LargeIcon.vue?vue&type=script&lang=js"
export * from "./LargeIcon.vue?vue&type=script&lang=js"

import "./LargeIcon.vue?vue&type=style&index=0&id=29739d3d&scoped=true&lang=css"

import exportComponent from "/Users/permartinson/Documents/GitHub/wpcedit/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29739d3d"]])

export default __exports__